import React from 'react'
import ReactDOM from 'react-dom'

import { Provider } from 'react-redux'

import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { getReCaptchaSitekey } from '../../utils/config'
import { loadAppState } from './common/fns'

import App from './app'
import makeStore from './store'

import '../../globals/scss/style.scss'
import './styles/scss/main.scss'

const siteKey = getReCaptchaSitekey(window.location.hostname)

export const store = makeStore(loadAppState())

ReactDOM.render(
  <Provider store={store}>
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      <App />
    </GoogleReCaptchaProvider>
  </Provider>,
  document.getElementById('main') || document.createElement('div'),
)
